<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t('vendormapping') }}</div>
        <div
          class="section-subTitle my-2"
        >{{ $tc('listofall') }} {{ $tc('vendor', 1) }} {{ $tc('incinematic') }}</div>
      </div>
      <div>
        <router-link
          variant="default"
          class="btn-blue"
          to="/fnb/add-vendor-mapping"
        >{{ $tc('add') }}</router-link>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing') }}
          <span>1-20</span>
          {{ $t('of') }}
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
          v-if="GridViewFlag"
        ></button>
        <button
          class="btnj btn-listView"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
          v-if="GridViewFlag"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table text-center" v-if="listView">
      <thead>
        <tr>
          <!-- <th>{{ $tc('cinema', 1) }}</th> -->
          <th>{{ $tc('rawmaterials', 2) }}</th>
          <th>{{ $tc('vendor', 1) }} {{ $t('name') }}</th>
          <th class="text-right">
            <span class="pr-5">{{ $tc('status', 1) }}</span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(vendorMap , vendorMapkey) in vendorMappingsList" :key="vendorMapkey">
          <!-- <td>{{ vendorMap.cine_name }}</td> -->
          <td>{{ vendorMap.rm_name }}</td>
          <td>{{ vendorMap.v_name }}</td>
          <td>
            <div class="d-flex justify-content-end align-items-center">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" checked disabled />
                <span class="switch-slider"></span>
              </label>

              <div>
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item @click="goToRoute('/fnb/edit-vendor-mapping',vendorMap)">
                    <span class="edit-pen"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="goToRoute('/fnb/view-vendor-mapping',vendorMap)">
                    <span class="icon-eye mr-1"></span>
                    {{ $t('view') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(loop , key) in vendorMappingsList"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <!-- <h6>{{ loop.cine_name }}</h6> -->
            <h6>{{ loop.rm_name }}</h6>
            <h6>{{ loop.v_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item @click="goToRoute('/fnb/edit-vendor-mapping',loop)">
                  <span class="edit-pen mr-1"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-vendor-mapping',loop)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="vendorMappingsList.length == 0">
        <h5>No Records Found</h5>
      </div>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      vendorMappingsList: []
    };
  },
  mounted() {
    this.getAllList();
  },
  beforeMount() {
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getAllList();
      } else {
        this.currentPage = event;
        this.getAllList();
      }
    },
    getAllList: function() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage
      };
      PosFnbService.GetAllVendorMapping(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.vendorMappingsList = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function(path, { rmv_id, vendor_id }) {
      this.$router.push({
        path: path,
        query: {
          vendor_id: vendor_id,
          rmv_id: rmv_id
        }
      });
    },
    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/vendorMapping.vue